module.exports = __webpack_public_path__ + "img/stena12.010a9204.jpg";